<template>
  <div class="qunti-huaxiang-detail child-detail">
    <ChildModal :title="$store.state.childModalTitle">
      <div class="single-line shangquanfenbu">
        <div class="chart-title">商圈分布</div>
        <div class="chart-content">
          <ShangquanFenbu
            :mapData="ShangquanFenbuData"
            v-if="ShangquanFenbuData"
          />
        </div>
      </div>
      <div class="single-line shangquankeliubianhua">
        <div class="chart-title">商圈客流变化趋势</div>
        <div class="chart-content">
          <AreaLine
            :chartData="ShangquanKeliuBianhuaData"
            id="shangquankeliubianhua"
          />
        </div>
      </div>
      <div class="zhanwei"></div>
    </ChildModal>
  </div>
</template>

<script>
import ChildModal from "@/components/Common/ChildModal.vue";
import ShangquanFenbu from "@/components/ZiyuanPinggu/GouwuShangquanFenxiDetail/ShangquanFenbu.vue";
import AreaLine from "@/components/Echarts/AreaLine.vue";

export default {
  name: "GouwuShangquanFenxiDetail",
  components: {
    ChildModal,
    ShangquanFenbu,
    AreaLine
  },
  props: {},
  data() {
    return {
      ShangquanFenbuData: null,
      ShangquanKeliuBianhuaData: null
    };
  },
  mounted() {
    // 请求商圈分布
    fetch("/data/ZiyuanPinggu/GouwuShangquanFenxiDetail/ShangquanFenbu.json")
      .then(response => {
        return response.json();
      })
      .then(json => {
        this.ShangquanFenbuData = json.data;
      });
    // 请求商圈趋势
    fetch(
      "/data/ZiyuanPinggu/GouwuShangquanFenxiDetail/ShangquanKeliuBianhua.json"
    )
      .then(response => {
        return response.json();
      })
      .then(json => {
        this.ShangquanKeliuBianhuaData = json.data;
      });
  },
  methods: {}
};
</script>

<style scoped lang="less">
.shangquanfenbu {
  .chart-content {
    width: 94%;
    height: 520px;
    position: relative;
  }
}
.shangquankeliubianhua {
  .chart-content {
    height: 320px;
  }
}
</style>
